import { Directive } from '@angular/core';
import { NG_VALIDATORS, Validator, ValidatorFn, UntypedFormControl, AbstractControl } from '@angular/forms';

@Directive({
  selector: '[pastYear][ngModel]',
  providers: [
    { provide: NG_VALIDATORS, useExisting: PastYearDirective, multi: true }
  ]
})
export class PastYearDirective implements Validator {
  validator: ValidatorFn;

  constructor() {
    this.validator = this.validatePastYear();
  }

  validate(c: UntypedFormControl) {
    return this.validator(c);
  }

  validatePastYear(): ValidatorFn {
    return (c: AbstractControl) => {

      let currentYear = (new Date()).getFullYear();
      let isValid = (c.value <= currentYear && c.value > 1000);

      if (isValid) {
        return null;
      } else {
        return {
          pastYear: {
            valid: false
          }
        };
      }
    }
  }
}
